import React, { useState, useEffect } from "react"
import Dashboard from "./pages/dashboard"
import Login from "./pages/login"
import { Toaster } from "react-hot-toast"
//import { BrowserRouter as Router } from "react-router-dom"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Cookies from "js-cookie"
//import { jwtDecode } from "jwt-decode"
import OauthCallback from "./oauthCallback"
import { subscribeToApiActivity } from "./utils/apiClient"
// import { AuthProvider } from "./utils/authContext"

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isLoading, setIsLoading] = useState(true) // Loading state
  const [authUser, setAuthUser] = useState({})
  const [isApiRunning, setIsApiRunning] = useState(false)

  useEffect(() => {
    const cookieToken = Cookies.get("user")

    if (cookieToken) {
      let decoded = JSON.parse(cookieToken)

      //decoded = { ...decoded, loggedInUserType: decoded.netIdRole }

      if (decoded) {
        setAuthUser(decoded)
      } else {
        console.error("Invalid token or unable to decode.")
      }
      setIsLoggedIn(true)
    } else {
      setIsLoggedIn(false)
    }

    setIsLoading(false) // Mark as loaded after processing
  }, [])

  useEffect(() => subscribeToApiActivity(setIsApiRunning), [])

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-message">Loading...</div>
      </div>
    )
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={
              isLoggedIn && !isLoading ? (
                <Dashboard
                  key={isLoggedIn ? "loggedIn" : "guest"}
                  authUser={authUser}
                />
              ) : (
                <Login onLogin={() => setIsLoggedIn(true)} />
              )
            }
          />
          <Route path="/oauth/callback" element={<OauthCallback />} />
        </Routes>

        <Toaster
          position="top-center"
          containerStyle={{
            top: "7px", // 👈 stick flush to the top
          }}
        />

        {isApiRunning && <div className="api-blocking-overlay" />}
      </div>
    </Router>
  )
}

export default App
